import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Avatar, List, ListItem, ListItemText, Paper } from '@mui/material';
import { AccessTime, Assessment, CloudUpload, LocalHospital, Person, Pets, Photo } from '@mui/icons-material';
import fileManagerMenuSx from './FileManagerMenu.styles';
import { useTheme } from '@mui/material/styles';
import clsx from 'clsx';
import { actions } from './FileManager.redux';

function makeMenuItems({ client_id, visit_id, patient_id, urpt_id }) {
    return [
        {
            name: 'upload',
            avatar: <CloudUpload />,
            className: 'secondaryColor',
            primary: 'Upload',
            secondary: null,
        },
        ...(urpt_id === null
            ? []
            : [
                  {
                      name: 'report',
                      avatar: <Assessment />,
                      className: 'indigoAvatar',
                      primary: 'Report',
                      secondary: 'Current Report',
                  },
              ]),
        ...(visit_id === null
            ? []
            : [
                  {
                      name: 'visit',
                      avatar: <LocalHospital />,
                      className: 'deepPurpleAvatar',
                      primary: 'Chart',
                      secondary: 'Current Chart',
                  },
              ]),
        ...(patient_id === null
            ? []
            : [
                  {
                      name: 'patient',
                      avatar: <Pets />,
                      className: 'patientsAvatar',
                      primary: 'Patient',
                      secondary: 'Current Patient',
                  },
              ]),
        ...(client_id === null
            ? []
            : [
                  {
                      name: 'client',
                      avatar: <Person />,
                      className: 'blueAvatar',
                      primary: 'Client',
                      secondary: 'Current Client',
                  },
              ]),
        {
            name: 'recent',
            avatar: <AccessTime />,
            className: 'indigoAvatar',
            primary: 'Recent',
            secondary: 'Recently Uploaded',
        },
        {
            name: 'browse',
            avatar: <Photo />,
            primary: 'Browse',
            secondary: 'Browse Uploaded Images',
        },
    ];
}

const FileManagerMenu = ({ client_id, visit_id, patient_id, urpt_id }) => {
    const dispatch = useDispatch(),
        page = useSelector((state) => state.files.page),
        [menuItems, setMenuItems] = useState(makeMenuItems({ client_id, visit_id, patient_id, urpt_id }));

    const theme = useTheme();
    const sx = fileManagerMenuSx(theme);

    useEffect(() => {
        setMenuItems(makeMenuItems({ client_id, visit_id, patient_id, urpt_id }));
    }, [client_id, patient_id, visit_id, urpt_id]);

    return (
        <Paper sx={sx.drawer} elevation={4}>
            <List>
                {menuItems.map((item) => {
                    const itemSx = {
                        ...(sx.menuItem || {}),
                        ...(page === item.name ? sx.menuActive : {}),
                    };

                    const avatarSx = sx[item.className] || {};

                    return (
                        <div key={item.name}>
                            <ListItem sx={itemSx} onClick={() => dispatch(actions.setPage(item.name))}>
                                <Avatar sx={avatarSx}>{item.avatar}</Avatar>
                                <ListItemText
                                    primary={item.primary}
                                    secondary={item.secondary || undefined}
                                    sx={sx.menuText}
                                />
                            </ListItem>
                        </div>
                    );
                })}
            </List>
        </Paper>
    );
};

export default FileManagerMenu;
